import { FC } from 'react';

import TextField from 'components/TextField/TextField';
import { isValidUrl } from 'utils/validations';

interface BookingRedirectSectionProps {
  control: any;
}

const BookingRedirectSection: FC<BookingRedirectSectionProps> = ({
  control,
}) => {
  return (
    <section>
      <p className="font-bold mb-1">Booking success redirect URL</p>
      <p className="text-12 text-darkest-grey mb-1">
        After a patient books through your embedded widget, your website will
        redirect to this page. Leave blank to keep the FirstIn confirmation.
      </p>
      <TextField
        id={'bookingSuccessRedirectUrl'}
        placeholder="https://example.com/thank-you"
        control={control}
        rules={{
          validate: (value) => {
            const url = value.trim();

            if (url === '' || isValidUrl(url)) return true;

            return 'Enter a valid URL starting with https://';
          },
        }}
      />
    </section>
  );
};

export default BookingRedirectSection;
